var _circle, _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path10, _mask6, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFamily = function SvgFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "-3 -3 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 18,
    fill: "#5C7AFF",
    fillOpacity: 0.25
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Family_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 13.715,
    width: 12,
    height: 10,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 13.715h12v10H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.384 23.403.25-.987H2.37c-.107 0-.188-.072-.238-.132a.714.714 0 0 1-.13-.588c.685-3.473 3.43-5.993 6.528-5.993.938 0 1.83.23 2.64.633l.25-.983a6.888 6.888 0 0 0-2.89-.638c-3.666 0-6.731 2.904-7.497 6.79-.192.972.455 1.899 1.336 1.899h7.014Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.384 23.403.25-.987H2.37c-.107 0-.188-.072-.238-.132a.714.714 0 0 1-.13-.588c.685-3.473 3.43-5.993 6.528-5.993.938 0 1.83.23 2.64.633l.25-.983a6.888 6.888 0 0 0-2.89-.638c-3.666 0-6.731 2.904-7.497 6.79-.192.972.455 1.899 1.336 1.899h7.014Z",
    fill: "#5C7AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.384 23.403.25-.987H2.37c-.107 0-.188-.072-.238-.132a.714.714 0 0 1-.13-.588c.685-3.473 3.43-5.993 6.528-5.993.938 0 1.83.23 2.64.633l.25-.983a6.888 6.888 0 0 0-2.89-.638c-3.666 0-6.731 2.904-7.497 6.79-.192.972.455 1.899 1.336 1.899h7.014Z",
    stroke: "#5C7AFF",
    strokeWidth: 0.4,
    mask: "url(#Family_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "Family_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 4.292,
    y: 6,
    width: 8,
    height: 9,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.292 6h8v9h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.292 10.314v.365a3.317 3.317 0 0 0 3.314 3.314 3.317 3.317 0 0 0 3.313-3.314v-.365A3.317 3.317 0 0 0 8.606 7a3.317 3.317 0 0 0-3.314 3.314Zm5.64.365a2.329 2.329 0 0 1-2.326 2.326A2.329 2.329 0 0 1 6.28 10.68v-.365a2.329 2.329 0 0 1 2.326-2.326 2.329 2.329 0 0 1 2.326 2.326v.365Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.292 10.314v.365a3.317 3.317 0 0 0 3.314 3.314 3.317 3.317 0 0 0 3.313-3.314v-.365A3.317 3.317 0 0 0 8.606 7a3.317 3.317 0 0 0-3.314 3.314Zm5.64.365a2.329 2.329 0 0 1-2.326 2.326A2.329 2.329 0 0 1 6.28 10.68v-.365a2.329 2.329 0 0 1 2.326-2.326 2.329 2.329 0 0 1 2.326 2.326v.365Z",
    fill: "#5C7AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.292 10.314v.365a3.317 3.317 0 0 0 3.314 3.314 3.317 3.317 0 0 0 3.313-3.314v-.365A3.317 3.317 0 0 0 8.606 7a3.317 3.317 0 0 0-3.314 3.314Zm5.64.365a2.329 2.329 0 0 1-2.326 2.326A2.329 2.329 0 0 1 6.28 10.68v-.365a2.329 2.329 0 0 1 2.326-2.326 2.329 2.329 0 0 1 2.326 2.326v.365Z",
    stroke: "#5C7AFF",
    strokeWidth: 0.4,
    mask: "url(#Family_svg__b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "Family_svg__c",
    maskUnits: "userSpaceOnUse",
    x: 19.014,
    y: 14.279,
    width: 12,
    height: 10,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.014 14.279h12v10h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.268 17.14a5.52 5.52 0 0 1 2.953-.872c2.846 0 5.317 2.22 6.008 5.398a.745.745 0 0 1-.125.617c-.07.087-.15.132-.235.132h-7.267l.25.988h7.017c.899 0 1.54-.96 1.326-1.947-.771-3.546-3.601-6.177-6.974-6.177-1.153 0-2.241.31-3.207.856l.254 1.005Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.268 17.14a5.52 5.52 0 0 1 2.953-.872c2.846 0 5.317 2.22 6.008 5.398a.745.745 0 0 1-.125.617c-.07.087-.15.132-.235.132h-7.267l.25.988h7.017c.899 0 1.54-.96 1.326-1.947-.771-3.546-3.601-6.177-6.974-6.177-1.153 0-2.241.31-3.207.856l.254 1.005Z",
    fill: "#5C7AFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.268 17.14a5.52 5.52 0 0 1 2.953-.872c2.846 0 5.317 2.22 6.008 5.398a.745.745 0 0 1-.125.617c-.07.087-.15.132-.235.132h-7.267l.25.988h7.017c.899 0 1.54-.96 1.326-1.947-.771-3.546-3.601-6.177-6.974-6.177-1.153 0-2.241.31-3.207.856l.254 1.005Z",
    stroke: "#5C7AFF",
    strokeWidth: 0.4,
    mask: "url(#Family_svg__c)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "Family_svg__d",
    maskUnits: "userSpaceOnUse",
    x: 18.824,
    y: 6.686,
    width: 8,
    height: 9,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.824 6.686h8v9h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.824 11v.365a3.317 3.317 0 0 0 3.313 3.314 3.318 3.318 0 0 0 3.315-3.314v-.366a3.317 3.317 0 0 0-3.314-3.313 3.318 3.318 0 0 0-3.314 3.313Zm5.64.365a2.329 2.329 0 0 1-2.327 2.326 2.329 2.329 0 0 1-2.326-2.326v-.366a2.329 2.329 0 0 1 2.326-2.326A2.329 2.329 0 0 1 25.463 11v.366Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.824 11v.365a3.317 3.317 0 0 0 3.313 3.314 3.318 3.318 0 0 0 3.315-3.314v-.366a3.317 3.317 0 0 0-3.314-3.313 3.318 3.318 0 0 0-3.314 3.313Zm5.64.365a2.329 2.329 0 0 1-2.327 2.326 2.329 2.329 0 0 1-2.326-2.326v-.366a2.329 2.329 0 0 1 2.326-2.326A2.329 2.329 0 0 1 25.463 11v.366Z",
    fill: "#5C7AFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.824 11v.365a3.317 3.317 0 0 0 3.313 3.314 3.318 3.318 0 0 0 3.315-3.314v-.366a3.317 3.317 0 0 0-3.314-3.313 3.318 3.318 0 0 0-3.314 3.313Zm5.64.365a2.329 2.329 0 0 1-2.327 2.326 2.329 2.329 0 0 1-2.326-2.326v-.366a2.329 2.329 0 0 1 2.326-2.326A2.329 2.329 0 0 1 25.463 11v.366Z",
    stroke: "#5C7AFF",
    strokeWidth: 0.4,
    mask: "url(#Family_svg__d)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "Family_svg__e",
    maskUnits: "userSpaceOnUse",
    x: 9.506,
    y: 18.164,
    width: 12,
    height: 8,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.506 18.164h12v8h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.514 24.116c-.062.463.247.884.662.884h8.877c.414 0 .724-.421.661-.884-.376-2.804-2.516-4.952-5.1-4.952-2.584 0-4.724 2.148-5.1 4.952Zm9.184-.104H11.53c.398-2.216 2.118-3.86 4.084-3.86 1.967 0 3.687 1.643 4.085 3.86Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.514 24.116c-.062.463.247.884.662.884h8.877c.414 0 .724-.421.661-.884-.376-2.804-2.516-4.952-5.1-4.952-2.584 0-4.724 2.148-5.1 4.952Zm9.184-.104H11.53c.398-2.216 2.118-3.86 4.084-3.86 1.967 0 3.687 1.643 4.085 3.86Z",
    fill: "#5C7AFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.514 24.116c-.062.463.247.884.662.884h8.877c.414 0 .724-.421.661-.884-.376-2.804-2.516-4.952-5.1-4.952-2.584 0-4.724 2.148-5.1 4.952Zm9.184-.104H11.53c.398-2.216 2.118-3.86 4.084-3.86 1.967 0 3.687 1.643 4.085 3.86Z",
    stroke: "#5C7AFF",
    strokeWidth: 0.4,
    mask: "url(#Family_svg__e)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "Family_svg__f",
    maskUnits: "userSpaceOnUse",
    x: 11.663,
    y: 11.443,
    width: 8,
    height: 8,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.663 11.443h8v8h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.663 15.713a2.954 2.954 0 0 0 2.951 2.952 2.954 2.954 0 0 0 2.951-2.952v-.318a2.955 2.955 0 0 0-2.95-2.951 2.955 2.955 0 0 0-2.952 2.95v.32Zm.988-.318c0-1.083.88-1.964 1.963-1.964 1.082 0 1.963.88 1.963 1.964v.318c0 1.083-.88 1.964-1.963 1.964a1.965 1.965 0 0 1-1.963-1.964v-.318Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.663 15.713a2.954 2.954 0 0 0 2.951 2.952 2.954 2.954 0 0 0 2.951-2.952v-.318a2.955 2.955 0 0 0-2.95-2.951 2.955 2.955 0 0 0-2.952 2.95v.32Zm.988-.318c0-1.083.88-1.964 1.963-1.964 1.082 0 1.963.88 1.963 1.964v.318c0 1.083-.88 1.964-1.963 1.964a1.965 1.965 0 0 1-1.963-1.964v-.318Z",
    fill: "#5C7AFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.663 15.713a2.954 2.954 0 0 0 2.951 2.952 2.954 2.954 0 0 0 2.951-2.952v-.318a2.955 2.955 0 0 0-2.95-2.951 2.955 2.955 0 0 0-2.952 2.95v.32Zm.988-.318c0-1.083.88-1.964 1.963-1.964 1.082 0 1.963.88 1.963 1.964v.318c0 1.083-.88 1.964-1.963 1.964a1.965 1.965 0 0 1-1.963-1.964v-.318Z",
    stroke: "#5C7AFF",
    strokeWidth: 0.4,
    mask: "url(#Family_svg__f)"
  })));
};

export default SvgFamily;